(() => {
  const container = document.querySelector('.shopify-policy__container');
  if (!container || container.dataset.kameReady) return;
  container.dataset.kameReady = 'true';

  const title = container.querySelector('.shopify-policy__title h1');
  if (title && !title.querySelector('.kame-hl')) {
    const text = title.textContent.trim();
    const cut = text.lastIndexOf(' ');
    if (cut > 0) {
      const accent = document.createElement('span');
      accent.className = 'kame-hl';
      accent.textContent = text.slice(cut + 1);
      title.textContent = text.slice(0, cut + 1);
      title.append(accent);
    }
  }

  const headings = [...container.querySelectorAll('.shopify-policy__body h2')].filter((h) => h.textContent.trim());
  if (headings.length < 3) return;

  const used = new Set();
  const nav = document.createElement('nav');
  nav.className = 'kame-toc';
  nav.setAttribute('aria-label', 'On this page');
  const label = document.createElement('p');
  label.className = 'kame-toc__label';
  label.textContent = 'On this page';
  const list = document.createElement('ol');

  const links = headings.map((heading) => {
    let id = heading.id;
    if (!id) {
      const base = heading.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'section';
      id = base;
      let n = 2;
      while (used.has(id) || document.getElementById(id)) id = `${base}-${n++}`;
      heading.id = id;
    }
    used.add(id);
    const item = document.createElement('li');
    const link = document.createElement('a');
    link.href = `#${id}`;
    link.textContent = heading.textContent.trim();
    item.append(link);
    list.append(item);
    return link;
  });

  nav.append(label, list);
  container.append(nav);
  container.classList.add('has-toc');

  if (!('IntersectionObserver' in window)) return;
  const byId = new Map(links.map((link) => [link.hash.slice(1), link]));
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        links.forEach((link) => link.removeAttribute('aria-current'));
        byId.get(entry.target.id)?.setAttribute('aria-current', 'true');
      });
    },
    { rootMargin: '-20% 0px -70% 0px' }
  );
  headings.forEach((heading) => observer.observe(heading));
})();
